import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

const RecordsButtonWithText = (props: UIProperties<RecordsButtonWithTextConfig>) => {
	const [isOver, setIsOver] = useState(false);
	const [forceHighlight, setforceHighlight] = useState(false);
    if(props.parameters.onForceHighlight) {
        props.parameters.onForceHighlight((shouldForce: boolean) => {
            setforceHighlight(shouldForce);
        });
    }
    
	useEffect(() => {

	}, [isOver])

	return (
		<div className='modal-disable-select' style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.width
		}}>
			<button onKeyDown={(e) => {
				if(props.parameters.isLastButton && (e.key === 'Tab' || e.which === 9) && !e.shiftKey) {
					setFocus('last-object-pr');
					e.preventDefault();
				}
			}} id={props.parameters.id} tabIndex={0} aria-label={props.parameters.ariaLabel} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all'
            }}
			aria-disabled={props.parameters.isDisabled}
			onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}} onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				<img style={{
					pointerEvents: 'none'
				}} src={props.parameters.srcIdle} />
				{isOver || props.parameters.shouldLeaveOn || forceHighlight ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src={props.parameters.srcHighlight} />) : (<div></div>)}

				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					left: '43%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '100%',
					fontSize: '22px',
					textAlign: 'right'
				}}>{props.parameters.text}</p>
			</button>
		</div>
	);

};

export interface RecordsButtonWithTextConfig extends BaseConfig{
	srcIdle: string;
	srcHighlight: string;
    isDisabled?: boolean;
	top: string;
	left: string;
	width: string;
	text: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	isLastButton?: boolean;
	ariaLabel?: string;
	id?: string;
	onClicked: () => void;
	onForceHighlight?: (forceHighlight: (shouldForce: boolean) => void) => void;
}

export default RecordsButtonWithText;